import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

/**
 * GraficaTorta — Gráfica de dona centrada y responsiva.
 *
 * Props:
 *   titulo  {string}                        Título opcional
 *   datos   {Array<{ name: string, valor: number }>}
 *   colores {string[]}                      Colores de cada segmento
 */
const GraficaTorta = ({ titulo = "", datos = [], colores = [] }) => {
    const total = datos.reduce((acc, item) => acc + item.valor, 0);

    const data = {
        labels: datos.map((item) => item.name),
        datasets: [
            {
                data: datos.map((item) => item.valor),
                backgroundColor: colores,
                hoverOffset: 6,
                borderWidth: 2,
                borderColor: "#fff",
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom",
                labels: { font: { size: 12 }, padding: 16 },
            },
            tooltip: {
                callbacks: {
                    label: (item) => {
                        const pct = total > 0 ? ((item.raw / total) * 100).toFixed(1) : 0;
                        return ` ${item.label}: ${item.raw} (${pct}%)`;
                    },
                },
            },
            datalabels: {
                display: (ctx) => ctx.dataset.data[ctx.dataIndex] > 0,
                color: "#fff",
                anchor: "center",
                align: "center",
                textStrokeColor: "rgba(0,0,0,0.55)",
                textStrokeWidth: 2,
                font: { weight: "bold", size: 13 },
                formatter: (value) =>
                    total > 0 ? `${((value / total) * 100).toFixed(1)}%` : "",
            },
        },
    };

    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            {titulo && (
                <h4 style={{ fontWeight: 700, marginBottom: 8, textAlign: "center", fontSize: 13 }}>
                    {titulo}
                </h4>
            )}
            <div style={{ width: "100%", height: "100%", minHeight: 220 }}>
                <Doughnut data={data} options={options} />
            </div>
        </div>
    );
};

export default GraficaTorta;